import React, { useState } from "react";
import {
  FaEllipsisV,
  FaExclamationCircle,
  FaTimes,
  FaXbox,
} from "react-icons/fa";

function _OrderRow({
  order,
  menuOpenId,
  setMenuOpenId,
  isSelected,
  onSelect,
  expandedId,
  setExpandedId,
  handelCancelModal,
  setSingleOrderToCancel,
}) {
  const [transactions, setTransactions] = useState({}); // ✅ state to store history per order

  const isMenuOpen = menuOpenId === order.COI_ID;
  const isExpanded = expandedId === order.COI_ID;

  const formatToMMDDYYYY = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);

    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const yyyy = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // Convert to 12-hour format

    return `${mm}/${dd}/${yyyy} ${hours}:${minutes} ${ampm}`;
  };

  return (
    <>
      <tr>
        {/* Select Checkbox */}
        <td>
          <input type="checkbox" checked={isSelected} onChange={onSelect} />
        </td>

        <td>
          <img
            src={`${process.env.REACT_APP_BASE_URL}Assets/Products/${
              order.PD_ID
            }/${order.PD_ProductPicPath[0] ?? "no-image.png"}`}
            alt={order.PD_Name}
            className="ord-prod-pic"
          />
        </td>
        <td>{order.PD_Name}</td>
        <td>{order.CP_Firstname + " " + order.CP_Lastname}</td>
        <td>{order.PD_ProductType}</td>
        <td>{formatToMMDDYYYY(order.COI_Created_At)}</td>
        <td>PHP {order.COI_UnitPrice}</td>
        <td> {order.COI_Quantity}</td>
        <td>PHP {order.COI_DP * order.COI_Quantity}</td>
        <td>PHP {order.COI_TotalAmount * order.COI_Quantity}</td>
        <td> {order.COI_Status}</td>

        <td className="td-actions">
          <div className="td-action-btns-wrapper">
            <FaTimes
              className="cancel"
              onClick={() => {
                setSingleOrderToCancel(order);
                handelCancelModal();
              }}
              title="CANCEL ORDER"
            />
          </div>
        </td>
      </tr>
    </>
  );
}

export default _OrderRow;
